// src/data/formConfigs.js
// Per-tort question sets for the multi-step form (quiz -> contact -> done)

export const formConfigs = {
  // ───────────────────────────────────────────────
  // 1) Dangerous & Defective Products
  // ───────────────────────────────────────────────
  "baby-formula-nec": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "radio",
        name: "premature",
        label: "Was the baby born premature?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "formula_brand",
        label: "Which formula was used most?",
        placeholder: "Select One *",
        options: ["Similac", "Enfamil", "Both", "Other / Not sure"],
        required: true,
      },
      {
        type: "radio",
        name: "nec_dx",
        label: "Was NEC (necrotizing enterocolitis) diagnosed?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  // ───────────────────────────────────────────────
  // 2) Exposure to Toxic Substances
  // ───────────────────────────────────────────────
  "roundup-cancer": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get an immediate Free PHONE consultation",
    cta: "DO I QUALIFY?",
    quiz: [
      {
        type: "radio",
        name: "exposure_subject",
        label:
          "Were you or a loved one directly exposed to the popular weed & grass killer Roundup?",
        options: [
          { value: "myself", label: "MYSELF" },
          { value: "loved_one", label: "LOVED ONE" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "diagnosis",
        label: "Have you been diagnosed with one of the following?",
        placeholder: "Select One *",
        options: [
          "Anaplastic Large T/Null-Cell Lymphoma (T/N-ALCL)",
          "B-Cell Lymphoma",
          "Burkitt Lymphoma",
          "Chronic Lymphocytic Leukemia (CLL)",
          "Diffuse large B-cell lymphoma (DLBCL)",
          "Follicular Lymphoma",
          "Hairy Cell Leukemia (HCL)",
          "Hodgkins Lymphoma (HL)",
          "Mantle Cell Lymphoma",
          "Mycosis Fungoides (T-MF)",
          "Non-Hodgkins Lymphoma (NHL)",
          "Peripheral T-cell lymphoma",
          "Plasmacytoma (B-PC)",
          "Primary CNS Lymphoma",
          "Sezary Syndrome (T-SS)",
          "Small Lymphocytic Lymphoma (SLL)",
          "T-Cell Lymphoma",
          "Other Lymphoma",
          "Other Leukemia",
          "Other Cancer",
          "None of the above",
        ],
        required: true,
      },
      {
        type: "number",
        name: "year_diagnosed",
        label: "What year were you diagnosed?",
        placeholder: "Year Diagnosed",
        min: 1950,
        max: new Date().getFullYear(),
      },
      {
        type: "radio",
        name: "has_lawyer",
        label:
          "Do you currently have a lawyer representing your Roundup claim?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "hair-relaxer-cancer": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get an immediate Free PHONE consultation",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "radio",
        name: "subject",
        label: "Who used chemical hair relaxers/straighteners most often?",
        options: [
          { value: "myself", label: "MYSELF" },
          { value: "loved_one", label: "LOVED ONE" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "diagnosis",
        label: "Any of the following diagnosed?",
        placeholder: "Select One *",
        options: [
          "Uterine Cancer",
          "Ovarian Cancer",
          "Endometrial Cancer",
          "Endometriosis",
          "Other / Not Sure",
          "None of the above",
        ],
        required: true,
      },
      {
        type: "number",
        name: "years_of_use",
        label: "About how many years were relaxers used?",
        placeholder: "Years of use",
        min: 0,
        max: 60,
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer for this matter?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "paraquat-parkinsons": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "SEE IF I QUALIFY",
    quiz: [
      {
        type: "radio",
        name: "exposure_role",
        label: "How were you exposed to Paraquat?",
        options: [
          { value: "farmer", label: "Farmer/Applicator" },
          { value: "grounds", label: "Groundskeeper" },
          { value: "neighbor", label: "Lived near spraying" },
          { value: "other", label: "Other" },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "diagnosis_pk",
        label: "Have you been diagnosed with Parkinson’s?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "number",
        name: "year_diagnosed",
        label: "What year were you diagnosed (if applicable)?",
        placeholder: "Year Diagnosed",
        min: 1950,
        max: new Date().getFullYear(),
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer for this matter?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "asbestos-lung-cancer": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "START FREE REVIEW",
    quiz: [
      {
        type: "radio",
        name: "subject",
        label: "Who was exposed to asbestos?",
        options: [
          { value: "myself", label: "MYSELF" },
          { value: "loved_one", label: "LOVED ONE" },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "lung_cancer_dx",
        label: "Have you (or they) been diagnosed with lung cancer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "radio",
        name: "smoking_history",
        label: "Any history of smoking?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "pfas-water": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "NEXT",
    quiz: [
      {
        type: "radio",
        name: "water_source",
        label: "What is your primary water source?",
        options: [
          { value: "municipal", label: "Municipal" },
          { value: "well", label: "Private well" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "diagnosis",
        label: "Any of the following conditions?",
        placeholder: "Select One *",
        options: [
          "Kidney Cancer",
          "Testicular Cancer",
          "Ulcerative Colitis",
          "Thyroid Disease",
          "High Cholesterol",
          "Other / Not Sure",
          "None of the above",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer for PFAS?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "la-wildfire": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "radio",
        name: "impact_type",
        label: "What best describes your wildfire impact?",
        options: [
          { value: "property_damage", label: "Property damage/loss" },
          { value: "smoke_damage", label: "Smoke-related damage" },
          { value: "evacuation_costs", label: "Evacuation/Living expenses" },
        ],
        required: true,
      },
      {
        type: "text",
        name: "affected_area",
        label: "Which city/area was affected?",
        placeholder: "City or neighborhood",
      },
      {
        type: "radio",
        name: "insurance_claim",
        label: "Have you filed an insurance claim?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "silicosis": {
  bannerTitle: "You May Qualify For Compensation",
  bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
  cta: "CHECK ELIGIBILITY",

  quiz: [
    {
      type: "radio",
      name: "silica_exposure",
      label: "Were you exposed to silica dust at work?",
      options: [
        { value: "yes", label: "YES" },
        { value: "no", label: "NO" },
      ],
      required: true,
    },

    {
      type: "select",
      name: "silicosis_diagnosis",
      label: "Have you been diagnosed with any of the following?",
      placeholder: "Select One *",
      options: [
        "Silicosis",
        "Lung fibrosis",
        "Respiratory disease",
        "COPD",
        "Other lung condition",
        "None of the above",
      ],
      required: true,
    },

    {
      type: "select",
      name: "exposure_duration",
      label: "Approximately how long were you exposed to silica dust?",
      placeholder: "Select One *",
      options: [
        "Less than 1 year",
        "1 to 5 years",
        "6 to 10 years",
        "More than 10 years",
      ],
      required: true,
    },

    {
      type: "radio",
      name: "has_lawyer",
      label: "Do you currently have a lawyer representing your claim?",
      options: [
        { value: "yes", label: "YES" },
        { value: "no", label: "NO" },
      ],
      required: true,
    },
  ],
},

  // ───────────────────────────────────────────────
  // 3) Defective Drugs & Medical Devices
  // ───────────────────────────────────────────────
  oxbryta: {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "SEE IF I QUALIFY",
    quiz: [
      {
        type: "radio",
        name: "took_oxbryta",
        label: "Did you (or a loved one) take Oxbryta?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "issues",
        label: "Were any serious side effects experienced?",
        placeholder: "Select One *",
        options: [
          "Hospitalization",
          "Severe headache",
          "Worsening anemia",
          "Other serious effects",
          "None / Not sure",
        ],
        required: true,
      },
      {
        type: "number",
        name: "year_started",
        label: "What year did you start Oxbryta? (approx.)",
        placeholder: "Year",
        min: 2000,
        max: new Date().getFullYear(),
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "bard-powerport": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "START FREE REVIEW",
    quiz: [
      {
        type: "radio",
        name: "implanted_port",
        label: "Was a Bard PowerPort (or similar port) implanted?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "complication",
        label: "Which complication occurred?",
        placeholder: "Select One *",
        options: [
          "Catheter fracture",
          "Catheter migration",
          "Infection/Sepsis",
          "Thrombosis/Embolism",
          "Device failure",
          "Other / Not sure",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "surgery",
        label: "Was removal or revision surgery required?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "hernia-mesh": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "radio",
        name: "mesh_implant",
        label: "Was a hernia repair performed with mesh?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "complications",
        label: "Any of the following complications?",
        placeholder: "Select One *",
        options: [
          "Chronic pain",
          "Infection",
          "Recurrence",
          "Adhesion",
          "Migration/Erosion",
          "Bowel obstruction",
          "Other / Not sure",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "revision",
        label: "Was a revision/removal surgery done?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "ozempic-wegovy": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "SEE IF I QUALIFY",
    quiz: [
      {
        type: "radio",
        name: "used_glp1",
        label:
          "Did you (or a loved one) use Ozempic, Wegovy, or similar GLP-1 drugs?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "complications",
        label: "Were any of the following complications diagnosed?",
        placeholder: "Select One *",
        options: [
          "Severe GI issues / Gastroparesis",
          "Bowel obstruction",
          "Gallbladder disease",
          "Pancreatitis",
          "Other serious effects",
          "None / Not sure",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "hospital",
        label: "Did complications require ER visit or hospitalization?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "depo-provera": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "START FREE REVIEW",
    quiz: [
    {
      type: "radio",
      name: "used_depo",
      label: "Have you (or a loved one) used Depo-Provera injections?",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
        { value: "not_sure", label: "Not sure" },
      ],
      required: true
    },
    {
      type: "select",
      name: "depo_injury",
      label: "Have you or your loved one been diagnosed with any of these injuries?",
      placeholder: "Select One",
      options: [
        "Brain Meningioma",
        "Spinal Meningioma",
        "Brain tumour",
        "Brain cyst",
        "Moderate to severe headache",
        "Nausea",
        "Dizziness",
        "Disorientation",
        "Other / Not sure",
      ],
    },
    {
      type: "text",
      name: "years_used",
      label: "About how many years was Depo used?",
      placeholder: "e.g., 3 years",
    },
    {
      type: "text",
      name: "diagnosis_year",
      label: "What year were you diagnosed (if applicable)?",
      placeholder: "e.g., 2021",
    },
    {
      type: "radio",
      name: "has_lawyer",
      label: "Do you currently have a lawyer?",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
      required: true
    },
  ],
},

  suboxone: {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "radio",
        name: "used_suboxone",
        label: "Did you (or a loved one) use Suboxone (film or tablets)?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "dental_issues",
        label: "Any dental issues after use?",
        placeholder: "Select One *",
        options: [
          "Tooth decay / Cavities",
          "Tooth erosion",
          "Extractions / Root canals",
          "Gum disease",
          "Other / Not sure",
          "None of the above",
        ],
        required: true,
      },
      {
        type: "number",
        name: "year_first_used",
        label: "First year Suboxone was used (approx.)",
        placeholder: "Year",
        min: 1990,
        max: new Date().getFullYear(),
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  dupixent: {
  bannerTitle: "You May Qualify For Compensation",
  bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
  cta: "CHECK ELIGIBILITY",

  quiz: [
  {
    type: "radio",
    name: "used_dupixent",
    label: "Have you (or a loved one) received Dupixent for at least 30 days?",
    options: [
      { value: "yes", label: "YES" },
      { value: "no", label: "NO" },
    ],
    required: true,
  },

  {
    type: "select",
    name: "dupixent_symptoms",  // DO NOT CHANGE
    label: "Have you (or a loved one) been diagnosed with any of the following medical conditions or injuries after using Dupixent?",
    placeholder: "Select One *",
    options: [
      "Cutaneous T-Cell Lymphoma (CTCL)",
      "Leukemic / Viral T-Cell Lymphoma",
      "Mycosis Fungoides (MF)",
      "Peripheral T-Cell Lymphoma (PTCL)",
      "Primary Cutaneous CD30+ Lymphoproliferative Disorders",
      "Sézary Syndrome (SS)",
      "Other cancer",
      "Other injury",
      "None of the above",
    ],
    required: true,
  },

  {
    type: "select",
    name: "year_first_used",   // name must remain EXACTLY this
    label: "Approximately how long after your first Dupixent injection were you (or your loved one) diagnosed with a serious medical condition?",
    placeholder: "Select One *",
    options: [
      "Less than 30 days",
      "30 to 90 days",
      "91 to 180 days",
      "181 to 365 days",
      "More than 365 days",
    ],
    required: true,
  },

  {
    type: "radio",
    name: "has_lawyer",
    label: "Do you currently have a lawyer representing your claim?",
    options: [
      { value: "yes", label: "YES" },
      { value: "no", label: "NO" },
    ],
    required: true,
  },
],

},

  // ───────────────────────────────────────────────
  // 4) Injury & Disability
  // ───────────────────────────────────────────────
  "auto-accident-personal-injury": {
    bannerTitle: "Free Case Review",
    bannerSubtitle: "No upfront fees — we only get paid if you do",
    cta: "START FREE REVIEW",
    quiz: [
      {
        type: "select",
        name: "incident_type",
        label: "What type of incident?",
        placeholder: "Select One *",
        options: [
          "Car accident",
          "Truck accident",
          "Motorcycle accident",
          "Pedestrian hit",
          "Bicycle crash",
          "Other injury",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "at_fault_other",
        label: "Was another party primarily at fault?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO / Not sure" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "injuries",
        label: "Any of the following injuries?",
        placeholder: "Select One *",
        options: [
          "Broken bones",
          "Head/Neck injury",
          "Back/Spine injury",
          "Soft tissue injuries",
          "Other serious injuries",
          "Not sure",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer for this case?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "ssdi-applications": {
    bannerTitle: "Get Help Filing SSDI",
    bannerSubtitle: "Fast, confidential review",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "radio",
        name: "working_now",
        label: "Are you currently working for pay?",
        options: [
          { value: "no", label: "NO" },
          { value: "yes", label: "YES" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "primary_condition",
        label: "Primary condition (pick the closest)",
        placeholder: "Select One *",
        options: [
          "Back/Spine disorder",
          "Cardiac condition",
          "Neurological condition",
          "Mental health",
          "Cancer",
          "Other / Not sure",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "prior_denial",
        label: "Have you been denied SSDI before?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_rep",
        label: "Do you currently have an attorney/rep for SSDI?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "birth-injury": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "Confidential review for families",
    cta: "START FREE REVIEW",
    quiz: [
      {
        type: "radio",
        name: "who_affected",
        label: "Who was injured?",
        options: [
          { value: "baby", label: "Baby" },
          { value: "mother", label: "Mother" },
        ],
        required: true,
      },
      {
        type: "select",
        name: "condition",
        label: "Any of the following conditions?",
        placeholder: "Select One *",
        options: [
          "Cerebral palsy",
          "Brachial plexus injury / Shoulder dystocia",
          "HIE (oxygen deprivation)",
          "Fractures",
          "Other / Not sure",
        ],
        required: true,
      },
      {
        type: "number",
        name: "birth_year",
        label: "Year of birth (approx.)",
        placeholder: "Year",
        min: 1980,
        max: new Date().getFullYear(),
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "video-game-addiction": {
    bannerTitle: "You May Qualify For Help",
    bannerSubtitle: "Confidential review for families",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "select",
        name: "age_group",
        label: "Child’s age group",
        placeholder: "Select One *",
        options: ["Under 10", "10–13", "14–17", "18+"],
        required: true,
      },
      {
        type: "select",
        name: "issues",
        label: "Main issues observed",
        placeholder: "Select One *",
        options: [
          "Sleep problems",
          "School decline / Truancy",
          "Depression/Anxiety",
          "Aggressive behavior",
          "Excessive spending",
          "Other / Not sure",
        ],
        required: true,
      },
      {
        type: "radio",
        name: "diagnosed",
        label: "Any professional diagnosis yet?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  // ───────────────────────────────────────────────
  // 5) Physical & Sexual Abuse
  // ───────────────────────────────────────────────
  "lds-abuse": {
    bannerTitle: "You May Qualify For Confidential Help",
    bannerSubtitle: "Compassionate, private review",
    cta: "START FREE REVIEW",
    quiz: [
      {
        type: "select",
        name: "age_at_time",
        label: "Your age at the time",
        placeholder: "Select One *",
        options: ["Under 10", "10–13", "14–17", "18+"],
        required: true,
      },
      {
        type: "radio",
        name: "reported",
        label: "Was it reported to church or police?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "text",
        name: "location",
        label: "Where did it occur? (city/state)",
        placeholder: "City, State",
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "roblox-discord-child-abuse": {
    bannerTitle: "You May Qualify For Confidential Help",
    bannerSubtitle: "Compassionate, private review",
    cta: "CHECK ELIGIBILITY",
    quiz: [
      {
        type: "select",
        name: "platform",
        label: "Platform involved",
        placeholder: "Select One *",
        options: ["Roblox", "Discord", "Both", "Other / Not sure"],
        required: true,
      },
      {
        type: "select",
        name: "age_at_time",
        label: "Minor’s age at the time",
        placeholder: "Select One *",
        options: ["Under 10", "10–13", "14–17"],
        required: true,
      },
      {
        type: "radio",
        name: "reported",
        label: "Was it reported to the platform or police?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
      },
      {
        type: "radio",
        name: "has_lawyer",
        label: "Do you currently have a lawyer?",
        options: [
          { value: "yes", label: "YES" },
          { value: "no", label: "NO" },
        ],
        required: true,
      },
    ],
  },

  "rideshare-assault": {
    bannerTitle: "You May Qualify For Compensation",
    bannerSubtitle: "Confidential, no upfront fees",
    cta: "START FREE REVIEW",
    quiz: [
  {
    type: "select",
    name: "platform",
    label: "Which rideshare company was involved in the incident?",
    placeholder: "Select One *",
    options: ["Uber", "Lyft", "Other / Not sure"],
    required: true,
  },
  {
    type: "radio",
    name: "role",
    label: "Were you the passenger or the driver?",
    options: [
      { value: "passenger", label: "Passenger" },
      { value: "driver", label: "Driver" },
    ],
    required: true,
  },
  {
    type: "radio",
    name: "assault_victim",
    label: "Were you (or a loved one) a victim of assault or improper sexual behavior?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
      { value: "prefer_not_say", label: "Prefer not to say" },
    ],
  },
  {
    type: "select",
    name: "victim_gender",
    label: "What is the victim's gender?",
    placeholder: "Select One",
    options: ["Male", "Female", "Non-binary", "Prefer not to say"],
  },
  {
    type: "select",
    name: "assault_when",
    label: "When did the unwanted conduct or assault occur?",
    placeholder: "Select One",
    options: [
      "Within the past year",
      "1 - 2 years ago",
      "3+ years ago",
      "I'm not sure",
    ],
  },
  {
    type: "select",
    name: "assault_type",
    label: "Which of the following best describes the most serious form of unwanted conduct you (or a loved one) experienced?",
    placeholder: "Select One",
    options: [
      "Verbal harassment",
      "Inappropriate touching",
      "Physical assault with threat of death (gun/weapons involved, choking, etc)",
      "Rape or attempted rape",
      "False imprisonment with overt sexual and extreme physical threats",
      "Other / Prefer not to say",
    ],
  },
  {
    type: "radio",
    name: "reported",
    label: "Was it reported to the company or police?",
    options: [
      { value: "yes", label: "YES" },
      { value: "no", label: "NO" },
    ],
  },
  {
    type: "radio",
    name: "has_receipt",
    label: "Do you have proof or a receipt for the ride?",
    options: [
      { value: "yes", label: "YES" },
      { value: "no", label: "NO" },
    ],
  },
  {
    type: "radio",
    name: "has_lawyer",
    label: "Do you currently have a lawyer?",
    options: [
      { value: "yes", label: "YES" },
      { value: "no", label: "NO" },
    ],
    required: true,
  },
],
  },

  "snapchat-addiction": {
  bannerTitle: "You May Qualify For Compensation",
  bannerSubtitle: "If Qualified, Get a Free PHONE consultation",
  cta: "CHECK ELIGIBILITY",

  quiz: [
     {
    type: "radio",
    name: "claim_for",
    label: "Are you filling this out for yourself or on behalf of a child?",
    options: [
      { value: "myself", label: "Myself" },
      { value: "dependent_minor", label: "Dependent minor" },
      { value: "someone_else", label: "Someone else" },
    ],
    required: true,
  },
  {
    type: "radio",
    name: "snapchat_abuse",
    label: "Were you or your child abused or groomed by someone that was met on Snapchat?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    required: true,
  },

  {
      type: "select",
      name: "snapchat_injuries",
      label: "Have you experienced any of the following?",
      placeholder: "Select One *",
      options: [
        "Depression",
        "Anxiety",
        "Eating disorder",
        "Self-harm thoughts",
        "Addiction-related behavior",
        "Other mental health symptoms",
        "None of the above",
      ],
      required: true,
    },

  {
    type: "select",
    name: "snapchat_connection_method",
    label: "How was the abuser first connected with on Snapchat?",
    placeholder: "Select One *",
    options: [
      "Quick Add",
      "Direct Messaging",
      "Shared Contacts",
      "Location Feature (Snap Map)",
      "Not sure",
      "Other",
    ],
    required: true,
  },

  {
      type: "select",
      name: "usage_duration",
      label: "Approximately how long was Snapchat regularly used?",
      placeholder: "Select One *",
      options: [
        "Less than 1 year",
        "1 to 2 years",
        "3 to 5 years",
        "More than 5 years",
      ],
      required: true,
    },

  // CONDITIONAL CHILD QUESTIONS

  {
    type: "select",
    name: "abuse_age_range",
    label: "How old were you/the child when the abuse or grooming started?",
    placeholder: "Select One *",
    options: [
      "3-7",
      "8-13",
      "14-17",
      "18+",
    ],
    required: true,
  },

  {
    type: "radio",
    name: "has_lawyer",
    label: "Do you currently have a lawyer?",
    options: [
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
    required: true,
  },
],
},
};

// Default config to use if a slug is missing
export const defaultFormConfigKey = "roundup-cancer";
